export default "/assets/images/virus-png-sm.7baa4359ccf89d9a.png";